import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface LuxuryLifestyleModalPayload {
  data?: null;
  type: ModalType.LuxuryLifestyle;
  isOpen?: boolean;
}

export const LuxuryLifestyleModal = React.forwardRef<
  HTMLElement,
  Pick<LuxuryLifestyleModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="Luxury Lifestyle Booking Portal"
      subtitle="Travel & Experiences on Chain"
      link={{
        title: 'Book to Enjoy MORE',
        link: {
          text: ECOSYSTEM_LINKS.useCases,
          href: ECOSYSTEM_LINKS.useCases,
        },
      }}
      icon={<Icons.StarDark />}
    >
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        Here, users can book hotels, flights, cruises, tours, and fine dining using blockchain technology.
      </Typography>
      <br />
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        Bookings are secured on-chain, and payments are made in $CRAT, often with access to special discounts and perks.
      </Typography>
      <br />
      <Typography variant="inherit" component="p" color="inherit" fontFamily="inherit">
        It turns luxury travel into a transparent, reward-filled experience powered by CratD2C.
      </Typography>
    </ModalSidebar>
  );
});
